import styled, { css } from "styled-components";
import { Button } from "@mui/material";

export const Wrapper = styled.div`
  display: flex;
  background: #fff;
  flex-direction: column;
  transition: background-color 0.5s ease;
  height: 100%;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
`;

export const SchedulingSection = styled.section`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  gap: 0.5rem;
  align-items: flex-start;
  width: 100%;
  position: relative;
  padding: 0 1.5rem;
`;

export const OptionsSection = styled.section`
  width: 100%;
  padding: 0 1.5rem;
  position: relative;
`;

export const OptionsDim = styled.div`
  position: absolute;
  background: transparent;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(2px);
  display: block;
  z-index: 2;
  cursor: not-allowed;
  display: ${(props) => (props.$isLearning ? "block" : "none")};
`;

export const LearningSection = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0 1.5rem;
`;

export const ModelInputArea = styled.div`
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  justify-content: flex-start;
  // flex-direction: column;
  width: 100%;
`;

export const InputWrapper = styled.div`
  width: ${(props) => props.$width};
`;

export const GraphContainer = styled.div`
  background: transparent;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: relative;
  grid-area: graph;
  height: 100%;
  width: 100%;
  // max-height: 460px;
`;

export const ResultSection = styled.section`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-template-areas:
    "graph"
    "progress";
  gap: 20px;
  height: 100%;
  // @media (max-width: 1024px) {
  //   grid-template-columns: 1fr;
  //   grid-template-areas:
  //     "graph"
  //     "models"
  //     "progress";
  // }
`;

export const SavedModels = styled.div`
  background: transparent;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  grid-area: models;
  position: relative;
  height: 300px;
`;

export const SaveButton = styled(Button)`
  && {
    ${(props) =>
      props.$isRainbow &&
      css`
        animation: rainbow 2s linear infinite;
        background: #ff0000;
        @keyframes rainbow {
          0% {
            background: #ff0000;
          }
          17% {
            background: #ff8000;
          }
          33% {
            background: #ffff00;
          }
          50% {
            background: #00ff00;
          }
          67% {
            background: #0000ff;
          }
          83% {
            background: #8000ff;
          }
          100% {
            background: #ff0000;
          }
        }
      `}
  }
`;

export const ModelList = styled.div`
  display: grid;
  grid-template-rows: repeat(2, 1fr);
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-top: 16px;
  overflow-x: auto;
  padding-bottom: 10px;
  &::-webkit-scrollbar {
    height: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
`;

export const GraphTitleBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 0px;
`;

export const OptionTitle = styled.div`
  margin-top: 0;
  font-family: Pretendard;
  font-size: 1.2rem;
  color: #333;
  font-weight: 500;
  text-align: center;
`;

export const GraphTitle = styled.div`
  margin-top: 0;
  font-family: Pretendard;
  font-size: 1.2rem;
  color: #333;
  font-weight: 500;
`;

export const GraphSectionBox = styled.div`
  position: relative;
  width: 100%;
  height: 370px;
`;

export const GraphSectionInnerBox = styled.div`
  width: 100%;
  height: 370px;
  display: grid;
  grid-template-areas: "overlap";
`;

export const GraphSectionCompleteMessage = styled.div`
  grid-area: overlap;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
`;

export const GraphSectionGraphBox = styled.div`
  grid-area: overlap;
  width: 100%;
  height: 100%;
  display: ${(props) => (props.$isLearning ? "block" : "none")};
  z-index: 1;
`;

export const EmptyState = styled.div`
  padding: 20px;
  text-align: center;
  color: black;
  font-family: Pretendard;
  position: absolute;
  top: 55%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-weight: 500;
`;

export const ModelButton = styled.div`
  padding: 12px;
  border: 2px solid ${(props) => (props.selected ? "#ff4444" : "#e0e0e0")};
  border-radius: 8px;
  background-color: ${(props) => (props.selected ? "#fff5f5" : "white")};
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  min-width: fit-content;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${(props) =>
    props.$isShaking &&
    css`
      animation: shake 0.5s infinite;
      @keyframes shake {
        0% {
          transform: translate(1px, 1px) rotate(0deg);
        }
        10% {
          transform: translate(-1px, -2px) rotate(-1deg);
        }
        20% {
          transform: translate(-3px, 0px) rotate(1deg);
        }
        30% {
          transform: translate(3px, 2px) rotate(0deg);
        }
        40% {
          transform: translate(1px, -1px) rotate(1deg);
        }
        50% {
          transform: translate(-1px, 2px) rotate(-1deg);
        }
        60% {
          transform: translate(-3px, 1px) rotate(0deg);
        }
        70% {
          transform: translate(3px, 1px) rotate(-1deg);
        }
        80% {
          transform: translate(-1px, -1px) rotate(1deg);
        }
        90% {
          transform: translate(1px, 2px) rotate(0deg);
        }
        100% {
          transform: translate(1px, -2px) rotate(-1deg);
        }
      }
    `};
`;

export const InnerWrapper = styled.div`
  display: flex;
  width: 85%;
  gap: 1rem;
`;

export const InnerSection = styled.div`
  width: 50%;
  gap: 1.5rem;
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  border: 1px solid rgb(var(--mui-mainColorChannels-light) / 0.12);
  padding: 1rem;
  position: relative;
  height: 85vh;
  border-radius: 8px;
`;

export const InnerRightSection = styled.div`
  width: 40%;
`;

export const InnerFooterWrapper = styled.div`
  width: 90%;
  height: 100px;
  max-width: 1400px;
  padding: 20px;
  display: flex;
  gap: 1rem;
`;

export const InnerFooterBtnBox = styled.div`
  width: 100%;
  display: flex;
  gap: 1rem;
`;

export const InnerLeftDim = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  backdrop-filter: blur(4px);
`;

export const InnerLeftDimText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const Title = styled.div`
  font-weight: 700;
  color: #111;
  margin-bottom: 0;
  font-size: 22px;
`;

export const SectionBox = styled.div`
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background-color: #f9f9f9;
`;

export const InnerSectionBox = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 20px 20px 0px 20px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
`;

export const InnerSectionContentContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  flex: 1;
  overflow-y: auto;
`;
